import { DatePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ConvertDurationInYearsPipe } from 'src/app/core/pipes/convert-duration-in-years.pipe';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';

@Component({
  selector: 'app-candidate-job-comparison',
  templateUrl: './candidate-job-comparison.component.html',
  styleUrls: ['./candidate-job-comparison.component.css'],
  providers: [DatePipe]
})
export class CandidateJobComparisonComponent implements OnInit {
  @Input() jobId;
  @Input() jobMatchId;
  @Input() candidateId;

  companyId: any;
  comparisonData: any;
  isSuperUserOr4dot5Admin: any;
  jobLocationForDisplay: any;
  educationMatches: any;
  educationNonMatches: any;
  educationAdditional: any;
  educationAlmost: any;
  educationPartial: any;
  experienceMatches: any;
  experienceNonMatches: any;
  experienceAdditional: any;
  experienceAlmost: any;
  techSkillsMatches: any;
  techSkillsNonMatches: any;
  techSkillsAdditional: any;
  techSkillsAlmost: any;
  operationalSkillsMatches: any;
  operationalSkillsNonMatches: any;
  operationalSkillsAdditional: any;
  operationalSkillsAlmost: any;
  softSkillsMatches: any;
  softSkillsNonMatches: any;
  softSkillsAdditional: any;
  softSkillsAlmost: any;
  otherSkillsMatches: any;
  otherSkillsNonMatches: any;
  otherSkillsAdditional: any;
  otherSkillsAlmost: any;
  certificationMatches: any;
  certificationNonMatches: any;
  certificationAdditional: any;
  certificationAlmost: any;
  compensationMatches: any;
  compensationNonMatches: any;
  compensationAdditional: any;
  compensationAlmost: any;
  totalJobExperience: any;
  jobTypeList: any;
  salaryDurationOptions: any;

  loadingFlag: boolean = true;
  compareByJobMatchId: boolean = true;

  constructor(
    private authService: AuthService,
    private userRoleService: UserRoleService,
    private jobMatchService: JobMatchService,
    private jobService: JobService,
    private datePipe: DatePipe,
    private convertDurationInYearsPipe: ConvertDurationInYearsPipe,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.comparisonData = [];
    this.loadingFlag = true;
    this.compareByJobMatchId = true;
    if (!this.jobMatchId) {
      this.compareByJobMatchId = false;
    }

    this.isSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
    this.getAllPreferredJobTypes();
    this.getSalaryDurationOptions();
    this.getCandidateJobComparison();
  }

  getAllPreferredJobTypes() {
    this.jobService.getAllJobTypes((data) => {
      this.jobTypeList = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    })
  }

  getSalaryDurationOptions() {
    this.jobService.getSalaryDurationOptions((data) => {
      this.salaryDurationOptions = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _getJobProfile(){
    this.jobService.getJobProfile(this.jobId, (data) => {
      if(data.experiences && data.experiences.length > 0 && data.experiences[0].duration) {
        this.totalJobExperience = data.experiences[0].duration; 
      }
    }, (error) => {
        // do nothing.
    });
}

  getCandidateJobComparison() {
    this.loadingFlag = true;
    if (this.compareByJobMatchId) {
      this.jobMatchService.getCandidateJobComparison(this.jobMatchId, (data) => {
        this.comparisonData = data;
        this._massageComparisonData();
        if(!this.experienceMatches.length && !this.experienceNonMatches.length && !this.experienceAlmost.length && !this.experienceAdditional.length) {
          this._getJobProfile();
        }
        this.loadingFlag = false;
      }, (error) => {
        console.log('candidate job match get error - ', error);
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // do nothing.
      });
    } else {
      this.jobService.getCandidateJobComparison(this.candidateId, this.jobId, this.companyId, (data) => {
        this.comparisonData = data;
        this._massageComparisonData();
        if(!this.experienceMatches.length && !this.experienceNonMatches.length && !this.experienceAlmost.length && !this.experienceAdditional.length) {
          this._getJobProfile();
        }
        this.loadingFlag = false;
      }, (error) => {
        console.log('candidate job match get error - ', error);
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // do nothing.
      });
    }

  }

  _setDateRange(experience) {
    experience.dateRange = "(";
    if(experience.startDate) {
        experience.dateRange = `${experience.dateRange}${this.datePipe.transform(experience.startDate, 'MMM, yyyy')} - `;
    }
    if(experience.endDate) {
        experience.dateRange = `${experience.dateRange}${this.datePipe.transform(experience.endDate, 'MMM, yyyy')}`;
    } else {
        experience.dateRange = `${experience.dateRange}Current`;
    }
    experience.dateRange = `${experience.dateRange})`;
    if(!experience.startDate && !experience.endDate) {
        experience.dateRange = "";
    }
}

  _massageComparisonData() {
    this.jobLocationForDisplay = '';
    if (this.comparisonData.jobLocation) {
      if (this.comparisonData.jobLocation.municipality) {
        this.jobLocationForDisplay += this.comparisonData.jobLocation.municipality;
      }
      if (this.comparisonData.jobLocation.city) {
        this.jobLocationForDisplay += (this.jobLocationForDisplay === '' ? this.comparisonData.jobLocation.city.name : (', ' + this.comparisonData.jobLocation.city.name));
      }
      if (this.comparisonData.jobLocation.region) {
        this.jobLocationForDisplay += (this.jobLocationForDisplay === '' ? this.comparisonData.jobLocation.region : (', ' + this.comparisonData.jobLocation.region));
      }
      if (this.comparisonData.jobLocation.state) {
        if (!this.comparisonData.jobLocation.region || (this.comparisonData.jobLocation.region !== this.comparisonData.jobLocation.state)) {
          this.jobLocationForDisplay += (this.jobLocationForDisplay === '' ? this.comparisonData.jobLocation.state : (', ' + this.comparisonData.jobLocation.state));
        }
      }
    }

    this.comparisonData.educationComparisons.forEach((comparison, key) => {
      if (comparison.candidateInstituteName === null || comparison.candidateInstituteName === "") {
        comparison.candidateInstituteName = "'Unknown'";
      }
    })

    this.comparisonData.experienceComparisons.forEach((comparison, key) => {
      if (comparison.company === null || comparison.company === "") {
        comparison.company = "'Unknown'";
      }
      this._setDateRange(comparison);
    });

    const categorizeAndEnhance = (skills: any[], type) => {
      return _.chain(skills)
        .map((skill: any) => {
          if(type === 'skills') {
            skill.displayExperience = this.setExperienceDisplay(skill);
          }
          return skill;
        })
        .groupBy('status')
        .value();
    };

    const educations = categorizeAndEnhance(this.comparisonData.educationComparisons, 'education');
    this.educationMatches = educations.MATCH || [];
    this.educationNonMatches = educations.NOT_MATCH || [];
    this.educationAdditional = educations.ADDITIONAL || [];
    this.educationAlmost = educations.ALMOST || [];
    this.educationPartial = educations.PARTIAL || [];

    const experiences = categorizeAndEnhance(this.comparisonData.experienceComparisons, 'experience');
    this.experienceMatches = experiences.MATCH || [];
    this.experienceNonMatches = experiences.NOT_MATCH || [];
    this.experienceAdditional = experiences.ADDITIONAL || [];
    this.experienceAlmost = experiences.ALMOST || [];

    const techSkills = categorizeAndEnhance(this.comparisonData.technicalSkillComparisons, 'skills');
    this.techSkillsMatches = techSkills.MATCH || [];
    this.techSkillsNonMatches = techSkills.NOT_MATCH || [];
    this.techSkillsAdditional = techSkills.ADDITIONAL || [];
    this.techSkillsAlmost = techSkills.ALMOST || [];

    const operationalSkills = categorizeAndEnhance(this.comparisonData.operationalSkillComparisons, 'skills');
    this.operationalSkillsMatches = operationalSkills.MATCH || [];
    this.operationalSkillsNonMatches = operationalSkills.NOT_MATCH || [];
    this.operationalSkillsAdditional = operationalSkills.ADDITIONAL || [];
    this.operationalSkillsAlmost = operationalSkills.ALMOST || [];

    const softSkills = categorizeAndEnhance(this.comparisonData.softSkillComparisons, 'skills');
    this.softSkillsMatches = softSkills.MATCH || [];
    this.softSkillsNonMatches = softSkills.NOT_MATCH || [];
    this.softSkillsAdditional = softSkills.ADDITIONAL || [];
    this.softSkillsAlmost = softSkills.ALMOST || [];

    const otherSkills = categorizeAndEnhance(this.comparisonData.otherSkillComparisons, 'skills');
    this.otherSkillsMatches = otherSkills.MATCH || [];
    this.otherSkillsNonMatches = otherSkills.NOT_MATCH || [];
    this.otherSkillsAdditional = otherSkills.ADDITIONAL || [];
    this.otherSkillsAlmost = otherSkills.ALMOST || [];

    const certifications = categorizeAndEnhance(this.comparisonData.certificationComparisons, 'certification');
    this.certificationMatches = certifications.MATCH || [];
    this.certificationNonMatches = certifications.NOT_MATCH || [];
    this.certificationAdditional = certifications.ADDITIONAL || [];
    this.certificationAlmost = certifications.ALMOST || [];

    const compensations = categorizeAndEnhance(this.comparisonData.compensationComparisons, 'compensation');
    this.compensationMatches = compensations.MATCH || [];
    this.compensationNonMatches = compensations.NOT_MATCH || [];
    this.compensationAdditional = compensations.ADDITIONAL || [];
    this.compensationAlmost = compensations.ALMOST || [];

    // Convert Object to Arrays
    // this.comparisonData.categoryScoreDTO.skillScoreDTO.individualRequiredSkillScoreInfoList = this.comparisonData.categoryScoreDTO.skillScoreDTO.individualRequiredSkillScoreInfo ? Object.entries(this.comparisonData.categoryScoreDTO.skillScoreDTO.individualRequiredSkillScoreInfo).map(([name, value]) => ({ name, value })) : [];
    // this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNonRequiredSkillScoreInfoList = this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNonRequiredSkillScoreInfo ? Object.entries(this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNonRequiredSkillScoreInfo).map(([name, value]) => ({ name, value })) : [];
    this.comparisonData.categoryScoreDTO.skillScoreDTO.individualRequiredSkillsScoreInfo = this.comparisonData.categoryScoreDTO.skillScoreDTO.individualRequiredSkillsScoreInfo ? this.comparisonData.categoryScoreDTO.skillScoreDTO.individualRequiredSkillsScoreInfo : [];
    this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNonRequiredSkillsScoreInfo = this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNonRequiredSkillsScoreInfo ? this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNonRequiredSkillsScoreInfo : [];
    this.comparisonData.categoryScoreDTO.skillScoreDTO.individualPreferredSkillsScoreInfo = this.comparisonData.categoryScoreDTO.skillScoreDTO.individualPreferredSkillsScoreInfo ? this.comparisonData.categoryScoreDTO.skillScoreDTO.individualPreferredSkillsScoreInfo : [];
    this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNiceToHaveSkillsScoreInfo = this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNiceToHaveSkillsScoreInfo ? this.comparisonData.categoryScoreDTO.skillScoreDTO.individualNiceToHaveSkillsScoreInfo : [];
    this.comparisonData.candidateAdditionalDetails = this.comparisonData.candidateAdditionalDetails ? this.comparisonData.candidateAdditionalDetails : {};
    this.comparisonData.workLocationsMatchStatus = this.setWorkLocationsMatchStatus(this.comparisonData.candidateAdditionalDetails.requisitionWorkLocationModes, this.comparisonData.workLocations);
  }

  setExperienceDisplay(skill) {
    let displayExperience = '';
    if ((skill.range && (skill.range.toLowerCase() === 'minimum' || skill.range.toLowerCase() === 'atleast')) || skill.plusTo === '+') {
      displayExperience = `${skill.experienceForJob}+ ${skill.experienceForJob > 1 ? 'years' : 'year'}`;
    } else if (skill.range && skill.range.toLowerCase() === 'maximum') {
      displayExperience = `<= ${skill.experienceForJob} ${skill.experienceForJob > 1 ? 'years' : 'year'}`;
    } else if (skill.plusTo === 'to' || (skill.actionWord && skill.actionWord != '')) {
      let minYears = Math.round(skill.minExperienceInMonths / 12);
      let maxYears = Math.round(skill.maxExperienceInMonths / 12);
      let label = maxYears > 1 ? 'years' : 'year';
      displayExperience = `${minYears} - ${maxYears} ${label}`;
    } else {
      displayExperience = this.convertDurationInYearsPipe.transform(skill.experienceForJob);
    }
    return displayExperience;
  }

  setWorkLocationsMatchStatus(jobWorkLocations, candidateWorkLocations) {
    if (!Array.isArray(jobWorkLocations) || jobWorkLocations.length === 0) {
      return "available";
    }

    if (Array.isArray(candidateWorkLocations) && candidateWorkLocations.length > 0) {
      const candidateLocationNames = candidateWorkLocations.map(loc => loc.name);

      const hasMatch = jobWorkLocations.some(location => candidateLocationNames.includes(location));
      return hasMatch ? "match" : "noMatch";
    }

    return "noMatch";
  }


}
